import * as React from 'react';
import { Switch, SwitchProps, withStyles } from '@material-ui/core';

const StyledSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 24,
    padding: 0,
    margin: '0 8px'
  },
  switchBase: {
    padding: 3,
    color: '#fff',
    '&$checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      '& + $track': {
        backgroundColor: theme.palette.secondary.main,
        opacity: 1
      }
    },
    '&$disabled': {
      cursor: 'not-allowed',
      '& + $track': {
        opacity: 0.5
      }
    }
  },
  thumb: {
    width: 18,
    height: 18
  },
  track: {
    width: '100%',
    height: '100%',
    borderRadius: 12,
    backgroundColor: theme.palette.grey[200],
    opacity: 1
  },
  checked: {},
  disabled: {}
}))(Switch);

const CustomSwitch: React.FC<SwitchProps> = (props) => <StyledSwitch disableRipple {...props} />;

export default CustomSwitch;
